import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "DocumentoActivoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "DocumentoActivoPage",
            ss: ss,
            ajax: {
                "url": ss.indexDocumentoActivo(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Activo', name: 'Activo', title: 'Activo' },
                { data: 'Carrera', name: 'Carrera', title: 'Carrera' },
                { data: 'CodigoActivo', name: 'CodigoActivo', title: 'Código Activo' },
                
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            documentoActivos: [],
            documentoActivo: {},
            carreras:[],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newDocumentoActivo() {
            this.documentoActivo = {};
            this.$refs['frm-documentoActivo'].show();
        },
        showDocumentoActivo(id) {
            this.isLoading=true;
            console.log(id);
            
            this.ss.showDocumentoActivo(id).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    console.log(response.data);
                    this.documentoActivo = response.data;
                    this.$refs['view-documentoActivo'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editDocumentoActivo() {
            this.$refs['frm-documentoActivo'].show();
            this.$refs['view-documentoActivo'].hide();
        },
        cancelDocumentoActivo() {
            if (this.documentoActivo.id) {
                this.$refs['view-documentoActivo'].show();
            }
            this.$refs['frm-documentoActivo'].hide();
        },
        saveDocumentoActivo() {
            this.ss.storeDocumentoActivo(this.documentoActivo).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-documentoActivo'].hide();
                    this.$refs['datatable-documentoActivo'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteDocumentoActivo() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyDocumentoActivo(this.documentoActivo)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-documentoActivo'].hide();
                                this.$refs['datatable-documentoActivo'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        
      

        getCarrera() {
            this.ss.listCarrera().then(
                (result) => {
                    let response = result.data;
                    this.carreras = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        
        draw() {
            window.$('.btn-datatable-DocumentoActivo').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showDocumentoActivo(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
            this.getCarrera();
        }
    }
};
